module.exports = __webpack_public_path__ + "img/Desinfektions--og-Konserveringsmidler.cdbe0974.jpg";